import _ from 'lodash';

/**
 * Apply a MongoDB-style update object to a plain doc, returning a new doc (the doc is not
 * mutated). Supports the operators the AI-edit flow emits: $set, $unset, $addToSet, $pull,
 * $push. Used to preview the "after" state of an edit (e.g. to render a diff).
 */
export function applyMongoUpdate(doc, update) {
  const out = _.cloneDeep(doc);
  _.each(update?.$set, (v, k) => _.set(out, k, v));
  _.each(update?.$unset, (_v, k) => _.unset(out, k));
  _.each(update?.$addToSet, (v, k) => {
    const arr = _.cloneDeep(_.get(out, k)) || [];
    const items = (v && _.isObject(v) && '$each' in v) ? v.$each : [v];
    for (const item of items) {
      if (!arr.some((x) => _.isEqual(x, item))) arr.push(item);
    }
    _.set(out, k, arr);
  });
  _.each(update?.$pull, (v, k) => {
    let arr = _.cloneDeep(_.get(out, k)) || [];
    if (v && _.isObject(v) && '$in' in v) {
      arr = arr.filter((x) => !v.$in.some((it) => _.isEqual(x, it)));
    } else {
      arr = arr.filter((x) => !_.isEqual(x, v));
    }
    _.set(out, k, arr);
  });
  _.each(update?.$push, (v, k) => {
    const arr = _.cloneDeep(_.get(out, k)) || [];
    const items = (v && _.isObject(v) && '$each' in v) ? v.$each : [v];
    _.set(out, k, [...arr, ...items]);
  });
  return out;
}

/** Top-level keys whose value differs between `before` and `after`. */
export function diffKeys(before, after) {
  const keys = _.union(_.keys(before), _.keys(after));
  return keys.filter((k) => !_.isEqual(before[k], after[k]));
}
